import Modal from "../Modal/Modal";
import CancelIcon from "@mui/icons-material/Cancel";
import styles from "./Location.module.css";
import { useDispatch, useSelector } from "react-redux";
import { hidePrompt, getPromptData } from "../../../dux/prompt";

const LocationModal = () => {
  const dispatch = useDispatch();
  const { category, data } = useSelector(getPromptData);

  // ✅ Only render if it's for location
  if (category !== "location") return null;

  return (
    <Modal>
      <div className={styles.container}>
        <span className={styles.close} onClick={() => dispatch(hidePrompt())}>
          <CancelIcon sx={{ height: 40, width: 40 }} />
        </span>
        <div className={styles.message}>{data.message || "Please select a location first!"}</div>
        <button
          className={styles.btn}
          onClick={() => dispatch(hidePrompt())}
        >
          OK
        </button>
      </div>
    </Modal>
  );
};

export default LocationModal;
